// src/components/Footer.js
import React from 'react';

function Footer() {
    const currentYear = new Date().getFullYear();
    return (
        <footer className="bg-secondary text-secondary-foreground p-4 text-center text-sm mt-auto">
            <p>&copy; {currentYear} Sistema Gestão de Presenças. Todos os direitos reservados.</p>
            <p>
                <a href="https://ucm.ac.mz/" target="_blank" rel="noopener noreferrer" className="hover:text-primary">
                    Universidade Católica de Moçambique
                </a>
            </p>
        </footer>
    );
}

export default Footer;